import { lazy, Suspense } from 'react';
import { useRoutes, type RouteObject, Navigate, Outlet } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import { useAuth } from '../context/AuthContext';

const AboutPage = lazy(() => import('../pages/about/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CourseDetailPage = lazy(() => import('../pages/courses/CourseDetailPage'));
const CollegesPage = lazy(() => import('../pages/colleges/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const DelegateMeetingsPage = lazy(() => import('../pages/delegate-meetings/page'));
const DelegateMeetingDetailPage = lazy(() => import('../pages/delegate-meetings/DelegateMeetingDetailPage'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login'));
const BlogIndexPage = lazy(() => import('../pages/blog/BlogIndexPage'));
const BlogPostPage = lazy(() => import('../pages/blog/BlogPostPage'));

const ProtectedRoute = () => {
  const { session, loading } = useAuth();
  
  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading Session...</div>;
  }

  return session ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

const routes: RouteObject[] = [
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <AdminPage />
      }
    ]
  },
  {
    element: <MainLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/courses', element: <CoursesPage /> },
      { path: '/courses/:country/:courseSlug', element: <CourseDetailPage /> },
      { path: '/colleges', element: <CollegesPage /> },
      { path: '/events', element: <EventsPage /> },
      { path: '/consultation', element: <ConsultationPage /> },
      { path: '/delegate-meetings', element: <DelegateMeetingsPage /> },
      { path: '/delegate-meetings/:id', element: <DelegateMeetingDetailPage /> },
      { path: '/services', element: <ServicesPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/terms', element: <TermsPage /> },
      { path: '/blog', element: <BlogIndexPage /> },
      { path: '/blog/:slug', element: <BlogPostPage /> },
    ]
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export function AppRoutes() {
  const element = useRoutes(routes);
  return <Suspense fallback={<div className="flex justify-center items-center h-screen">Loading...</div>}>{element}</Suspense>;
}
